import { render, staticRenderFns } from "./BirthdayCoinSettings.vue?vue&type=template&id=4c72b1ff&scoped=true&"
import script from "./BirthdayCoinSettings.vue?vue&type=script&lang=ts&"
export * from "./BirthdayCoinSettings.vue?vue&type=script&lang=ts&"
import style0 from "./BirthdayCoinSettings.vue?vue&type=style&index=0&id=4c72b1ff&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72b1ff",
  null
  
)

export default component.exports